
import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//comopnents:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getFamilia, modifyFamilia, removeFamilia, addFamilia, updateFamiliaDB } from '../../actions/familia_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresFamilia extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getFamilia();
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkFamilia = (familia) => {
        if (this.props.familia.find(c => (c.descr === familia.descr) && (c.id !== familia.id))) {
            this.messageDialog(`Ya existe una familia con descripción ${familia.descr}`);
            return false;
        } else if (!familia.descr.trim()) {
            this.messageDialog('Por favor, introduzca una Descripción');
            return false;
        } else if (!familia.cod.trim()) {
            this.messageDialog('Por favor, introduzca un Código');
            return false;
        } else if (this.props.familia.find(c => (c.cod === familia.cod) && (c.id !== familia.id))) {
            this.messageDialog(`Ya existe una familia con código ${familia.cod}`);
            return false;
        }

        else return true;
    };

    addNewFamilia = familia => {
        this.props.setSaveState(true);
        this.props.addFamilia(familia);
    };

    newFamilia = () => {
        this.props.openDialog('EditCvFamilia', {
            cvFamilia: {},
            okHandler: this.addNewFamilia,
            checkFamilia: this.checkFamilia,
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        for (let i = fromRow; i <= toRow; i++) {
            let updatedRow = update(this.props.familia[i], { $merge: updated });
            if (this.checkFamilia(updatedRow)) {
                this.props.setSaveState(true);
                this.props.modifyFamilia(updatedRow);
            }
        };

    };

    handleDeleteRow = familia => {
        this.props.setSaveState(true);
        this.props.removeFamilia(familia);
    };

    render() {

        const { classes } = this.props;


        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div style={{ marginBottom: 20 }}>
                        <NeuriteGrid
                            id="m_r_f"
                            columns={[
                                { key: 'cod', name: 'Código', editable: true, dragable: false, width: 55 },
                                { key: 'descr', name: 'Descripción', editable: true, dragable: false, width: 200 },
                            ]}
                            rows={this.props.familia}
                            height={500}
                            buttonEdit={false}
                            buttonDelete={true}
                            buttonNew={true}
                            onNewRowClick={this.newFamilia}
                            onRowsUpdated={this.handleGridRowsUpdated}
                            onDeleteClick={this.handleDeleteRow}
                        />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.familia.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateFamiliaDB(this.props.familia)
                }}>Guardar</Button>
            </div >
        );

    };

};

MaeAuxiliaresFamilia.propTypes = {
    //state
    familia: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getFamilia: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyFamilia: PropTypes.func.isRequired,
    removeFamilia: PropTypes.func.isRequired,
    addFamilia: PropTypes.func.isRequired,
    updateFamiliaDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        familia: state.familia.familias,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getFamilia,
        openDialog,
        hideDialog,
        modifyFamilia,
        removeFamilia,
        addFamilia,
        updateFamiliaDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresFamilia));